import { render, staticRenderFns } from "./product-brandable.vue?vue&type=template&id=042b7bf1&scoped=true&"
import script from "./product-brandable.vue?vue&type=script&lang=js&"
export * from "./product-brandable.vue?vue&type=script&lang=js&"
import style0 from "./product-brandable.vue?vue&type=style&index=0&id=042b7bf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b7bf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042b7bf1')) {
      api.createRecord('042b7bf1', component.options)
    } else {
      api.reload('042b7bf1', component.options)
    }
    module.hot.accept("./product-brandable.vue?vue&type=template&id=042b7bf1&scoped=true&", function () {
      api.rerender('042b7bf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/product-brandable.vue"
export default component.exports